import python from "../Assets/python.png";
import java from "../Assets/java.png";
import c from "../Assets/c.png";
import javascript from "../Assets/javascript.png";
import typescript from "../Assets/typescript.png";
import react from "../Assets/react.png";
import angular from "../Assets/angular.png";
import express from "../Assets/express.png";
import nodejs from "../Assets/nodejs.png";
import mongodb from "../Assets/mongodb.png";
import mysql from "../Assets/mysql.png";
import firebase from "../Assets/firebase.png";
import nestjs from "../Assets/nestjs.png";
import springboot from "../Assets/springboot.png";
import babylonjs from "../Assets/babylonjs.svg";
import ionic from "../Assets/ionic.png";
import docker from "../Assets/docker.png";
import flask from "../Assets/flask.svg";
import more from "../Assets/Click to see more skills.svg";
import materialui from "../Assets/materialui.svg";
import html from "../Assets/html.png";
import css from "../Assets/css.png";
import coordinates from "../Assets/coordinates.jpeg";
import hostelmanagement from "../Assets/hostelmanagement.jpeg";
import pizzamaker from "../Assets/pizzamaker.png";
import nilconnect from "../Assets/nilconnect.png";
import massmaildispenser from "../Assets/massmaildispenser.png";
import eva from "../Assets/eva.jpeg";
import vishal from "../Assets/vishal.jpg";
import pyspark from "../Assets/pyspark.png";
import jmeter from "../Assets/jmeter.png";
import junit from "../Assets/junit.svg";
import aws from "../Assets/aws.svg";
import tailwind from "../Assets/tailwind.svg";
import git from "../Assets/git.svg";
import word from "../Assets/word.svg";
import excel from "../Assets/excel.svg";
import powerpoint from "../Assets/powerpoint.svg";
import gcp from "../Assets/gcp.svg";
import postgresql from "../Assets/postgresql.png";
import huggingface from "../Assets/huggingface.svg";
import freshedge from "../Assets/freshedge.png";
import healthcaredashboard from "../Assets/healthcaredashboard.png";
import smartdoor from "../Assets/smartdoor.png";
import ollama from "../Assets/ollama.png";
import llava from "../Assets/llava.svg";
import chromadb from "../Assets/chromadb.svg";
import kotlin from "../Assets/kotlin.svg";

export const imagepaths = (imageName) => {
  switch (imageName) {
    case "Python":
      return python;
    case "Java":
      return java;
    case "C":
      return c;
    case "Javascript":
      return javascript;
    case "Typescript":
      return typescript;
    case "React":
      return react;
    case "Angular":
      return angular;
    case "Express":
      return express;
    case "Nodejs":
      return nodejs;
    case "Mongodb":
      return mongodb;
    case "Mysql":
      return mysql;
    case "Firebase":
      return firebase;
    case "Nestjs":
      return nestjs;
    case "Springboot":
      return springboot;
    case "Babylonjs":
      return babylonjs;
    case "Ionic":
      return ionic;
    case "Docker":
      return docker;
    case "Flask":
      return flask;
    case "Html":
      return html;
    case "Css":
      return css;
    case "ChromaDB":
      return chromadb;
    case "Kotlin":
      return kotlin;
    case "LLaVA":
      return llava;
    case "Ollama":
      return ollama;
    case "Click to see more skills":
      return more;
    case "Vishal":
      return vishal;
    case "MaterialUI":
      return materialui;
    case "Coordinates":
      return coordinates;
    case "FreshEdge":
      return freshedge;
    case "SmartDoor":
      return smartdoor;
    case "HealthCareDashboard":
      return healthcaredashboard;
    case "Pizzamaker":
      return pizzamaker;
    case "Hostelmanagement":
      return hostelmanagement;
    case "Nilconnect":
      return nilconnect;
    case "Massmaildispenser":
      return massmaildispenser;
    case "Eva":
      return eva;
    case "PySpark":
      return pyspark;
    case "JMeter":
      return jmeter;
    case "JUnit":
      return junit;
    case "AWS":
      return aws;
    case "Tailwind":
      return tailwind;
    case "Git":
      return git;
    case "Word":
      return word;
    case "Excel":
      return excel;
    case "GCP":
      return gcp;
    case "PostgreSQL":
      return postgresql;
    case "PowerPoint":
      return powerpoint;
    case "HuggingFace":
      return huggingface;
    default:
      return null;
  }
};
